import { RARITY_SHADOW_CLASS } from '@/molecules/CardThumb/const';
import { RARITY_API_REF } from '@/types/modifiers/references';
import { SIZE } from '@/types/utils';
import clx from 'classnames';
import { RARITY_GEM_MAP } from 'constants/icons';
import { PropsWithChildren } from 'react';

const RARITY_FOILED_CLASS: Record<keyof typeof RARITY_API_REF, string> = {
  RARE: 'from-nublu-400 via-nublu-200 to-nublu-400',
  UNIQUE: 'from-gold-400 via-gold-200 to-gold-400',
  COMMON: 'from-nublu-200 via-mercury-200 to-nublu-200',
};

const SIZE_TO_WRAPPER_CLASS = {
  [SIZE.SM]: 'p-1 rounded-sm',
  [SIZE.MD]: 'p-1 rounded-md',
  [SIZE.LG]: 'p-1.5 rounded-lg',
};

type Props = {
  className?: string;
  foiled?: boolean;
  rarity?: keyof typeof RARITY_API_REF | null;
  showRarityGem?: boolean;
  size?: SIZE;
};

const CardWrapper = ({
  children,
  className,
  foiled,
  rarity,
  showRarityGem = false,
  size = SIZE.LG,
}: PropsWithChildren<Props>) => (
  <div
    className={clx(
      'relative bg-transparent w-fit',
      SIZE_TO_WRAPPER_CLASS[size],
      foiled &&
        `bg-200% bg-gradient-foil-rotation
      from-20% via-40% to-60%
      animate-background-move`,
      foiled && rarity && RARITY_FOILED_CLASS[rarity],
      foiled && rarity && size === SIZE.LG && RARITY_SHADOW_CLASS[rarity],
      className,
    )}
  >
    {rarity && showRarityGem && (
      <div className={clx('absolute z-10 left-1/2 -translate-x-1/2', foiled ? '-top-2.5' : '-top-1.5')}>
        {RARITY_GEM_MAP[rarity]}
      </div>
    )}
    <div
      className={clx(
        'relative rounded-lg w-full',
        !foiled && rarity && size === SIZE.LG && RARITY_SHADOW_CLASS[rarity],
      )}
    >
      {children}
    </div>
  </div>
);

export default CardWrapper;
